import { render, staticRenderFns } from "./NewEditQuestionnaire.vue?vue&type=template&id=6a314b64&"
import script from "../../models/push-notifications/new-edit-questionnaire.ts?vue&type=script&lang=ts&"
export * from "../../models/push-notifications/new-edit-questionnaire.ts?vue&type=script&lang=ts&"
import style0 from "./NewEditQuestionnaire.vue?vue&type=style&index=0&id=6a314b64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports